import React from 'react';
import PropTypes from 'prop-types';
import Label from 'components/common/label/label';
import { serializeClasses } from 'utilities/css';
import FormHelperText from '@mui/material/FormHelperText';

export const LabelDecorator = (Component) => {
  const LabeledComponent = ({
    inlineLabel,
    label,
    id,
    hidden,
    className,
    helperText,
    ...rest
  }) => {
    if (!label) {
      return <Component {...rest} className={className} id={id} />;
    }
    // @todo implement conditional requirements for proptypes and remove this log
    if (!id) {
      // eslint-disable-next-line no-console
      console.error(Component, 'The prop `id` is marked as required in LabelDecorator, but its value is `undefined`.');
    }
    const labelClasses = serializeClasses([
      inlineLabel && 'inline',
      hidden && 'hidden',
    ]);

    const componentClasses = serializeClasses([
      className,
      inlineLabel && 'inline',
    ]);

    return (
      <>
        <Label className={labelClasses} label={label} htmlFor={id} />
        {
          helperText && (
          <FormHelperText style={{ marginTop: '0', marginBottom: '4px' }}>
            {helperText}
          </FormHelperText>
          )
        }
        <Component
          {...rest}
          id={id}
          className={componentClasses}
          hidden={hidden}
          inline={inlineLabel}
        />
      </>
    );
  };
  LabeledComponent.propTypes = {
    className: PropTypes.string,
    hidden: PropTypes.bool,
    inlineLabel: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.node]),
    id: PropTypes.string,
    helperText: PropTypes.string
  };
  LabeledComponent.defaultProps = {
    className: undefined,
    inlineLabel: false,
    hidden: false,
    label: undefined,
    id: undefined,
    helperText: undefined
  };
  return LabeledComponent;
};

export default LabelDecorator;
